import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, logout } from '../utils/auth';
import './Footer.css'; // Import dedicated CSS for Footer

const Footer = () => {
    const [isAuth, setIsAuth] = useState(false);
    const [showMap, setShowMap] = useState(false);
    const navigate = useNavigate();

    // Effect to check authentication status
    useEffect(() => {
        const checkAuthStatus = () => {
            setIsAuth(isAuthenticated());
        };
        
        checkAuthStatus();
        
        // Listen for login/logout events from other tabs/windows
        window.addEventListener('storage', checkAuthStatus);
        
        // Also, create a custom event to listen for login/logout within the same tab
        window.addEventListener('authChange', checkAuthStatus);

        return () => {
            window.removeEventListener('storage', checkAuthStatus);
            window.removeEventListener('authChange', checkAuthStatus);
        };
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowMap(true);
        }, 3000); // 3 second delay
        return () => clearTimeout(timer);
    }, []);

    const handleLogout = async () => {
        await logout();
        // Manually trigger authChange event for immediate update in other components
        window.dispatchEvent(new CustomEvent('authChange'));
        navigate('/'); // Navigate to home on logout
    };

    return (
        <footer className="footer section">
            <div className="shape shape__big"></div>
            <div className="shape shape__small"></div>

            <div className="footer__container container grid">
                <div className="footer__content">
                    <a href="/" className="footer__logo">
                        <picture>
                            <source srcSet="/img/logo-nav-desk.webp" type="image/webp" />
                            <img className='logoNav'src="/img/logo-nav-desk.png" width='100' alt='Logo'/>
                        </picture>
                    </a>
                    <div className='footer__links'>
                        <p className="footer__description">
                            De Alemania a tu garaje
                        </p>
                        <p className="footer__description">
                            Teléfono: +34 664067584
                        </p>
                        <p className="footer__description">
                        Carretera de Logroño, 4, Oyón (Álava)
                        </p>
                    </div>
                </div>

                <div className="footer__content">
                    <h3 className="footer__title">
                        Compañía
                    </h3>
                    <ul className="footer__links">
                        <li><a href="/financiación" className="footer__link">Financiación</a></li>
                        <li><a href="/garaje" className="footer__link">Coches</a></li>
                        <li><a href="/tasación" className="footer__link">Tasación</a></li>
                    </ul>
                </div>

                <div className="footer__content">
                    <h3 className="footer__title">
                        Información
                    </h3>
                    <ul className="footer__links">
                        <li><a href="/contacto" className="footer__link">Contacto</a></li>
                        <li><a href="/legal" className="footer__link">Legal</a></li>
                        <li>
                            {isAuth ? (
                                <button onClick={handleLogout} className="footer__link" style={{background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left', color: 'var(--text-color)', fontFamily: 'var(--body-font)', fontSize: 'var(--normal-font-size)'}}>Logout</button>
                            ) : (
                                <Link to="/login" className="footer__link">Admin</Link>
                            )}
                        </li>
                    </ul>
                </div>

                <div className="footer__content footer__social-mobile-only">
                    <h3 className="footer__title">
                        Síguenos
                    </h3>
                    <ul className="footer__social">
                        <a href="https://www.facebook.com/"  className="footer__social-link">
                            <i className="ri-facebook-fill"></i>
                        </a>
                        <a href="https://www.instagram.com/"  className="footer__social-link">
                            <i className="ri-instagram-line"></i>
                        </a>
                        <a href="https://twitter.com/"  className="footer__social-link">
                            <i className="ri-twitter-line"></i>
                        </a>
                    </ul>
                </div>

                <div className="footer__content">
                    <h3 className="footer__title">
                        Dónde estamos
                    </h3>
                    <div className="footer__map-container">
                        {showMap ? (
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2930.0000000000005!2d-2.4444444444444446!3d42.50000000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd451111111111111%3A0x1234567890abcdef!2sLogro%C3%B1o%20Errepidea%2C%204%2C%2001320%20Oy%C3%B3n-Oion%2C%20Araba!5e0!3m2!1sen!2ses!4v1678901234567!5m2!1sen!2ses"
                                width="100%"
                                height="200"
                                style={{border:0}}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Ubicación de Manna Cars"
                            ></iframe>
                        ) : (
                            <div>Loading map...</div>
                        )}
                    </div>
                </div>
            </div>
            <span className="footer__copy">
                &#169; Manacars. Todos los derechos reservados.
            </span>
        </footer>
    );
}

export default Footer;